export enum ModuleCompletionSelectionType {
    All = 'all',
    Selected = 'selected',
    Filtered = 'filtered',
}
